<template>
  <div class="columns is-marginless is-paddingless section section-details">
    <div class="mgt-20px column is-10" v-if="materiel">
      <div class="card" id="caracteristiques">
        <header class="header-card">
          <p>
            {{ $t('materiel.caracteristiques') }}
          </p>
        </header>
        <div class="card-content columns">
          <div class="column is-2">
            <app-logo readOnly
                      :elementId="materiel.id"
                      :libelleElement="$t('materiel.libelleForLogo',
                      { code: materiel.code })">
            </app-logo>
          </div>
          <div class="column is-10 columns is-multiline">
            <div class="column is-3">
              <b-field :label="$t('materiel.codeConsultation')"
                      custom-class="has-text-link">
                <p>{{ materiel.code }}</p>
              </b-field>
            </div>
            <div class="column is-3">
              <b-field :label="$t('materiel.typeMaterielConsultation')"
                      custom-class="has-text-link">
                <p>{{ materiel.type === null ? '' : materiel.type.libelle }}</p>
              </b-field>
            </div>
            <div class="column is-3">
              <b-field :label="$t('materiel.dispositionConsultation')"
                      custom-class="has-text-link">
                <p>{{ materiel.disposition }}</p>
              </b-field>
            </div>
            <div class="column is-3">
              <b-field :label="$t('materiel.localisationConsultation')"
                      custom-class="has-text-link">
                <p>{{ materiel.localisation === null ? '' : materiel.localisation.libelle }}</p>
              </b-field>
            </div>
            <div class="column is-3">
              <b-field :label="$t('materiel.venantDeConsultation')" custom-class="has-text-link">
                <p>{{ materiel.enVenantDe }}</p>
              </b-field>
            </div>
            <div class="column is-3">
              <b-field :label="$t('materiel.allantVersConsultation')"
                      custom-class="has-text-link">
                <p>{{ materiel.enAllantVers }}</p>
              </b-field>
            </div>
          </div>
        </div>
      </div>
      <format :materiel="materiel" class="mgt-30px" id="format"></format>
      <detail-tlpe :materiel="materiel" class="mgt-30px" id="tlpe"></detail-tlpe>
      <div class="mgt-30px">
        <montage-demontage-consultation :dispositifPublicitaire="materiel" id="montage">
        </montage-demontage-consultation>
      </div>
      <collectivite :materiel="materiel" class="mgt-30px" id="collectivite"></collectivite>
      <div v-if="materiel.numerique && materiel.informationsNumeriques">
        <div class="card mgt-30px" id="numerique">
          <header class="header-card">
            <p>
              {{ $t('materiel.numeriqueDevice.title') }}
            </p>
          </header>
          <div class="card-content columns is-multiline">
            <div class="column is-3">
              <b-field :label="$t('materiel.numeriqueDevice.timeLoop')"
                          custom-class="has-text-link">
                  <p>{{materiel.informationsNumeriques.timeLoop}}</p>
              </b-field>
            </div>
            <div class="column is-3">
              <b-field :label="$t('materiel.numeriqueDevice.spotNumber')"
                          custom-class="has-text-link">
                  <p>{{materiel.informationsNumeriques.spotNumber}}</p>
              </b-field>
            </div>
            <div class="column is-3">
              <b-field :label="$t('materiel.numeriqueDevice.timeSpot')"
                          custom-class="has-text-link">
                  <p>{{materiel.informationsNumeriques.timeSpot}}</p>
              </b-field>
            </div>
            <div class="column is-3">
              <b-field :label="$t('materiel.numeriqueDevice.idPlayer')"
                       custom-class="has-text-link">
                <p>{{ materiel.idPlayer }}</p>
              </b-field>
            </div>
          </div>
        </div>
      </div>
      <div class="card mgt-30px" id="visibilite">
        <header class="header-card">
          <p>
            {{ $t('materiel.visibilite') }}
          </p>
        </header>
        <div class="card-content columns is-multiline">
          <div class="columns column is-multiline is-3">
            <div class="column is-12 pdb-0">
            <b-field :label="$t('materiel.visibleSurLaConsultation')" custom-class="has-text-link">
                <p>{{ materiel.visibleSurLa === 'Aucun' ? '' : materiel.visibleSurLa }}</p>
            </b-field>
            </div>
            <div class="column is-12 pdb-0">
            <b-field :label="$t('materiel.angleVisionConsultation')" custom-class="has-text-link">
                <p>{{ materiel.angleVision === null ? '' : materiel.angleVision.libelle }}</p>
            </b-field>
            </div>
            <div class="column is-12 pdb-0">
            <b-field :label="$t('materiel.azimutConsultation')" custom-class="has-text-link">
                <p>{{ materiel.azimut }}</p>
            </b-field>
            </div>
          </div>
          <div class="column is-9">
            <gmap-map class="is-height-320" :center="center"
                :zoom="adresse.longitude !== null && adresse.latitude !== null
                ? constantes.ZOOM_DEFAULT_EMPLACEMENT : constantes.ZOOM_DEFAULT_SANS_MARKER">
              <div v-if="adresse.longitude && adresse.latitude">
                <gmap-marker :key="m.num" v-for="(m) in markers"
                :position="m.position" :icon="m.icon">
                </gmap-marker>
              </div>
            </gmap-map>
          </div>
          <div class="column is-3">
            <b-field :label="$t('materiel.visibleFeuConsultation')" custom-class="has-text-link">
            <p>{{ materiel.visibleDunFeu ? $t('general.oui') :  $t('general.non')}}</p>
            </b-field>
          </div>
          <div class="column is-3">
            <b-field :label="$t('materiel.visibleIntersectionConsultation')"
                    custom-class="has-text-link">
            <p>{{ materiel.visibleDuneIntersection ? $t('general.oui') :  $t('general.non')}}</p>
            </b-field>
          </div>
          <div class="column is-3">
            <b-field :label="$t('materiel.eclaireConsultation')" custom-class="has-text-link">
            <p>{{ materiel.eclaire ? $t('general.oui') :  $t('general.non')}}</p>
            </b-field>
          </div>
        </div>
      </div>
      <div class="card mgt-30px" id="axe">
        <header class="header-card">
          <p>
            {{ $t('materiel.axe') }}
          </p>
        </header>
        <div class="card-content columns is-multiline">
          <div class="column is-2">
            <b-field :label="$t('materiel.isolementConsultation')" custom-class="has-text-link">
              <p>{{ materiel.isolement === null ? '' :
                  materiel.isolement === true ? $t('general.oui') :  $t('general.non') }}</p>
            </b-field>
          </div>
          <div class="column is-2">
            <b-field :label="$t('materiel.ecartAxeConsultation')" custom-class="has-text-link">
              <p>{{ materiel.ecartAxe }}</p>
            </b-field>
          </div>
          <div class="column is-2">
            <b-field :label="$t('materiel.ecartVoieConsultation')" custom-class="has-text-link">
              <p>{{ materiel.ecartVoie }}</p>
            </b-field>
          </div>
          <div class="column is-3">
            <b-field :label="$t('materiel.longueurApprocheConsultation')"
                    custom-class="has-text-link">
              <p> {{ materiel.longueurApproche }}</p>
            </b-field>
          </div>
        </div>
      </div>
      <div class="card mgt-30px" id="commentaire">
        <header class="header-card">
          <p>
            {{ $t('materiel.commentaire') }}
          </p>
        </header>
        <div class="card-content columns is-multiline">
          <div class="column is-12">
            <b-field :label="$t('materiel.commentaireConsultation')"
                    custom-class="has-text-link">
              <p>
                  {{ materiel.commentaire }}
              </p>
            </b-field>
          </div>
        </div>
      </div>
      <div class="card mgt-30px" id="pj">
        <header class="header-card">
          <p>
            {{ $t('materiel.pj') }}
          </p>
        </header>
        <div class="card-content">
          <app-pieces-jointes :checkPermissions=checkPermissions(constantes.EMPLACEMENT.maj)
                              class="mgt-20px"
                              readOnly
                              deletable
                              autoSave>
          </app-pieces-jointes>
        </div>
      </div>
    </div>
    <div class="column is-2">
      <div class="is-fixed mgt-20px">
        <dots-menu :steps="steps">
        </dots-menu>
        <information-create-update-user class="mgr-20px" :data="materiel">
        </information-create-update-user>
      </div>
    </div>
  </div>
</template>
<script>
import { createNamespacedHelpers } from 'vuex';
import format from '@/components/gabed/materiel/detailMateriel/format';
import { EMPLACEMENT } from '@/configuration/gabed/permissionsGabedConf';
import collectivite from '@/components/gabed/materiel/detailMateriel/collectivite';
import Logo from '@/components/general/Logo';
import PiecesJointes from '@/components/general/piecesJointes';
import detailTlpe from '@/components/gabed/materiel/detailMateriel/tlpe';
import montageDemontageConsultation from '@/components/gabed/dispositif/c_montageDemontage';
import centerMapGetter from '@/services/general/map/centerMapGetter';
import markersGetter from '@/services/general/map/markersGetter';
import {
  ZOOM_DEFAULT_EMPLACEMENT,
  CENTER_DEFAULT,
  ZOOM_DEFAULT_SANS_MARKER,
  COULEUR_PUCE_DEFAULT,
} from '@/configuration/general/carteConf';
import dotsMenu from '@/components/general/dotsMenu';
import InformationCreateUpdateUser from '@/components/general/informationCreateUpdateUser';

const permissions = createNamespacedHelpers('permissions');

export default {
  props: {
    materiel: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      constantes: {
        EMPLACEMENT,
        ZOOM_DEFAULT_EMPLACEMENT,
        ZOOM_DEFAULT_SANS_MARKER,
      },
      steps: [
        {
          name: this.$i18n.t('detailMateriel.steps.caracteristiques'),
          ref: '#caracteristiques',
          active: true,
        },
        {
          name: this.$i18n.t('detailMateriel.steps.format'),
          ref: '#format',
          active: false,
        },
        {
          name: this.$i18n.t('detailMateriel.steps.tlpe'),
          ref: '#tlpe',
          active: false,
        },
        {
          name: this.$i18n.t('detailMateriel.steps.montage'),
          ref: '#montage',
          active: false,
        },
        {
          name: this.$i18n.t('detailMateriel.steps.collectivite'),
          ref: '#collectivite',
          active: false,
        },
        {
          name: this.$i18n.t('detailMateriel.steps.numerique'),
          ref: '#numerique',
          active: false,
        },
        {
          name: this.$i18n.t('detailMateriel.steps.visibilite'),
          ref: '#visibilite',
          active: false,
        },
        {
          name: this.$i18n.t('detailMateriel.steps.axe'),
          ref: '#axe',
          active: false,
        },
        {
          name: this.$i18n.t('detailMateriel.steps.commentaire'),
          ref: '#commentaire',
          active: false,
        },
        {
          name: this.$i18n.t('detailMateriel.steps.pj'),
          ref: '#pj',
          active: false,
        },
      ],
    };
  },
  components: {
    appPiecesJointes: PiecesJointes,
    montageDemontageConsultation,
    appLogo: Logo,
    detailTlpe,
    format,
    collectivite,
    dotsMenu,
    InformationCreateUpdateUser,
  },
  computed: {
    ...permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    center() {
      if (this.adresse.longitude !== null
        && this.adresse.latitude !== null) {
        return centerMapGetter(this.adresse, this.markers);
      }
      return centerMapGetter(CENTER_DEFAULT, []);
    },
    adresse() {
      return this.materiel.dispositif.adresse;
    },
    markers() {
      return markersGetter(this.adresse, COULEUR_PUCE_DEFAULT, this.materiel.azimut);
    },
  },
};

</script>
